import { ProductProps } from '../../type'
import { ProductCategory, ProductTag } from '../../enum'
import imageBanner from './img/banner.png'
import imageArchitecture1 from './img/architecture-1.jpg'
import imageArchitecture2 from './img/architecture-2.jpg'
import imageArchitecture3 from './img/architecture-3.jpg'
import imageArchitecture4 from './img/architecture-4.jpg'
import imageTable1 from './img/table-1.jpg'
import imageTable2 from './img/table-2.jpg'
import imageCertificate1 from './img/certificate-1.jpg'
import imageCertificate2 from './img/certificate-2.jpg'

export const ceebox251: ProductProps = {
  tag: ProductTag.ESS,
  category: ProductCategory.CommercialEnergyStorageSystems,
  pathName: 'ce-e-box-251',
  banner: imageBanner,
  title: 'CE-eBox-251',
  description:
    'The energy storage system switches between Running, Standby,\nand Shutdown modes based on commands or fault detection/clearance conditions',
  features: [
    {
      type: 'image-list',
      content: [
        { title: 'Appearance', images: [imageArchitecture1] },
        { title: 'Appearance', images: [imageArchitecture2, imageArchitecture3, imageArchitecture4] },
      ],
    },
  ],
  specImages: [imageTable1, imageTable2],
  certificateImages: [imageCertificate1, imageCertificate2],
}
